export default function NewTag({ signupDate }: { signupDate?: Date }) {
  if (!signupDate) {
    return <></>;
  }

  const date = new Date(signupDate);
  const today = new Date();
  const diffTime = Math.abs(today.getTime() - date.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays > 14) {
    return <></>;
  }
  return (
    <span className="relative text-white text-sm font-bold">
      <span className="absolute bottom-0 transform h-1/2 opacity-90 bg-[#00BFFF] left-[-10%] right-[-10%]"></span>
      <span className="relative">NEW</span>
    </span>
  );
}
